export const ASANA_SKIPPED = "skipped";
export const ASANA = "Asana";
